import React from 'react';
import ExperienceCard from "./ExperienceCard";
import groupeBir from "../../assets/img/groupe-bir.png";
import kiwip from "../../assets/svg/kiwip.svg";
import netways from "../../assets/img/netways.jpeg";
import consconte from "../../assets/img/consconte.jpg";

const Experience = () => {
    return (

        <div className="experience" id="experience">
            <div className="container">
                <h1> Experience </h1>
                <div className="card-container">
                    <ExperienceCard img={groupeBir} company="Groupe BIR" job="Développeur Fullstack" mission="Développement Fullstack avec Angular, .NET et 4D" date="2024 - Aujourd'hui" />
                    <ExperienceCard img={kiwip} company="Kiwip" job="Développeur Fullstack" mission="Application Mobile (Android, Kotlin), Montre Android, Symfony Api" date="2020 - 2024" />
                    <ExperienceCard img={netways} company="Netways" job="Développeur Fullstack" mission="Application Mobile Android, Api Platform, Symfony" date="2018 - 2019" />
                    <ExperienceCard img={consconte} company="Consconte" job="Développeur Fullstack" mission="Symfony, MongoDB, Prototype Android" date="2020 - 2021" />
                </div>
            </div>
        </div>
    );
};

export default Experience;
